import { DRUG_SORT_KEYS, type DrugSortKey } from '@/entities/drug/api/drug.api';
import { Button } from '@/shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu';
import { Icon } from '@/shared/components/ui/icon';

const DRUG_SORT_LABELS: Record<DrugSortKey, string> = {
  DRUG_NAME_ASC: '의약품 이름순',
  PHARMA_FEE_RATE_DESC: '수수료율 높은순',
};

/** M-11 정렬 — 제목 줄 오른쪽 Button Medium · Text/black + nav-arrow-down 24 (Figma 833:6257) → Context Menu */
export const DrugSortMenu = ({
  value,
  onChange,
}: {
  value: DrugSortKey;
  onChange: (sort: DrugSortKey) => void;
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="text"
        size="medium"
        aria-label={`정렬: ${DRUG_SORT_LABELS[value]}`}
        rightIcon={<Icon name="nav-arrow-down-line-24" />}
      >
        {DRUG_SORT_LABELS[value]}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      {DRUG_SORT_KEYS.map((k) => (
        <DropdownMenuItem
          key={k}
          selected={k === value}
          onSelect={() => onChange(k)}
        >
          {DRUG_SORT_LABELS[k]}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
